import { StreamerUser } from './StreamerUser'

export interface Media {
  streamingServer: StreamingServer
  chatServer: ChatServer
  mediaStreamers: StreamerUser[]
  ownerStreamer: StreamerUser
  mediaDive: any
  mediaDecorations?: any
  badges?: any
  collab?: any
  habaneroServer: any
  mediaId: number
  title: string
  description: string
  openTime: string
  startTime: string
  closeTime: string
  thumbnail: string
  likes: number
  ownerVliveId: string
  state: MediaState
  watchCount: number
  followerCount: number
  streamingType: number
  distributor: number
  livePauseExpireSecond?: number
  broadcastingMethod: BroadcastingMethod
  isDive: boolean
  isPaused: boolean
  isCustomRtmp: boolean
  isWarWolf: boolean
  isRandomCollab: boolean
  playingGameId: number | null
  multiGameServiceIndex: number
  broadcasterShareURL: string
  viewerShareURL: string
  collabAcceptanceType: number
}

export interface StreamingServer {
  mediaId: number
  publishEndpoint?: string
  streamingKey?: string
  viewEndpoint: string
  keyFrameRate: string
}

export interface ChatServer {
  mediaId: number
  endpointIpaddr: string
  endpointPort: number
}

export const BroadcastingMethods = {
  RTMP: 0,
  ClientRendering: 1,
} as const
export type BroadcastingMethod =
  typeof BroadcastingMethods[keyof typeof BroadcastingMethods]

export const MediaStates = {
  Reserved: 10,
  Ready: 20,
  Live: 30,
  Closed: 40,
  Deleted: 100,
} as const
export type MediaState = typeof MediaStates[keyof typeof MediaStates]
